









































































import { Vue, Component, InjectComponent, VueComponent, Marking, ProductProperty } from "@zoovu/runner-browser-api";
import { TopProductView } from "@zoovu/runner-web-design-base";

@Component({
  name: "TopProductView",
  mixins: [TopProductView],
})
export default class TopProductViewExtended extends Vue {
  @InjectComponent("ProductComparisonSelectorView")
  productComparisonSelectorView: VueComponent;

  @InjectComponent("ProductPriceView")
  productPriceView: VueComponent;

  get hasNeutralProperty(): boolean {
    return this.recommendation.properties.some((property: ProductProperty) => property.marking === Marking.NEUTRAL);
  }
}
